import Api from '@/api/index'

const state = {
  all: [],
}

const getters = {}

const actions = {
  async getAll({ commit }, params) {
    const labs = await Api.Laboratory.getAll(params)
    if (labs !== null) {
      commit('setLabs', labs)
      return labs
    }
    return []
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const lab = await Api.Laboratory.getById(params)
    if (lab !== null) {
      return lab
    }
    return null
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    lab
  ) {
    const result = await Api.Laboratory.save(lab)
    return result
  },

  async delete(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Laboratory.delete(params)
    return result
  },
}

const mutations = {
  setLabs(state, labs) {
    state.all = labs.items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
